module.exports = __webpack_public_path__ + "img/objects-align-top.66e7af06.svg";